export default {
  namespaced: true,
  // vuex存储公共状态的文件
  state: {
    play: false,
    playIcon: 'http://haoliangxinjiu.com/imags/暂停.png', // 播放样式
    soundIcon: 'http://haoliangxinjiu.com/imags/静音.png', // 声音样式
    volume: false, // 音量
    moveOffsetX: 0, // 拖动开始时点击的位置
    curWidth: 0, // 拖动开始时进度条的宽度
    moveType: '', // 移动的类型，用来标明是否在拖动进度条
    duration: 0, // 显示总时长
    currentTime: '0:00', // 显示播放到的当前时间
    progressHeight: 70, // 滑到位置高度
    moveOffsetY: 0, // 拖动开始时点击的位置 音量
    curHeight: 0, // 拖动开始时进度条的宽度 音量
    moveTypeVol: '', // 移动的类型，用来标明是否在拖动进度条 音量
    progressWidth: 0 // 滑动到位置的宽度
  },
  getters: {
    // 对当前用户角色可以访问的路由进行过滤
    authNavs (state) {
      // 获取缓存中的角色名
      const role = localStorage.getItem('role') || ''
      // 查找state中的navs的roles中有缓存中的角色名，让有角色名的路由显示
      return state.navs.filter(nav => nav.roles.includes(role))
    }
  },
  mutations: {
    ISMOBILE (state) { // 检测是否是移动端
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        state.playIcon = 'http://haoliangxinjiu.com/imags/播放.png'
      } else {
        state.playIcon = 'http://haoliangxinjiu.com/imags/暂停.png'
      }
    },
    // 拖动开始时进度条的宽度
    SET_PLAY (state, play) {
      state.play = play
    },
    // 拖动开始时进度条的宽度
    SET_CURWIDTH (state, curWidth) {
      state.curWidth = curWidth
    },
    // 是否在拖动进度条
    SET_MOVETYPE (state, moveType) {
      state.moveType = moveType
    },
    // 修改拖动开始时点击的位置
    SET_MOVEOFFSETX (state, moveOffsetX) {
      state.moveOffsetX = moveOffsetX
    },
    // 修改滑块宽度
    SET_PROGRESSWIDTH (state, progressWidth) {
      state.progressWidth = progressWidth
    },
    // 当前播放时长
    SET_CURRENTTIME (state, currentTime) {
      state.currentTime = currentTime
    },
    // 修改总时长
    SET_DURATION (state, duration) {
      state.duration = duration
    },
    // 修改滑到位置高度
    SET_PROGRESSHEIGHT (state, progressHeight) {
      state.progressHeight = progressHeight
    },
    // 进度条音量
    SET_CURHEIGHT (state, curHeight) {
      state.curHeight = curHeight
    },
    // 小滑块音量
    SET_MOVETYPRVOL (state, moveTypeVol) {
      state.moveTypeVol = moveTypeVol
    },
    // 调节音量
    SET_MOVEOFFSETY (state, moveOffsetY) {
      state.moveOffsetY = moveOffsetY
    },
    // 修改声音样式
    SET_SOUNDICON (state, soundIcon) {
      if (soundIcon) {
        state.soundIcon = soundIcon
      } else {
        if (state.soundIcon === 'http://haoliangxinjiu.com/imags/声音.png') {
          state.soundIcon = 'http://haoliangxinjiu.com/imags/静音.png'
        } else {
          state.soundIcon = 'http://haoliangxinjiu.com/imags/声音.png'
        }
      }
    },
    // 修改视频播放状态
    SET_PLAYICON (state, playIcon) {
      if (playIcon) {
        state.playIcon = playIcon
      } else {
        if (state.playIcon === 'http://haoliangxinjiu.com/imags/播放.png') {
          state.playIcon = 'http://haoliangxinjiu.com/imags/暂停.png'
        } else {
          state.playIcon = 'http://haoliangxinjiu.com/imags/播放.png'
        }
      }
    },
    // 设置视频音量大小
    SET_VOLUME (state, volume) {
      state.volume = volume
      // sessionStorage.setItem('volume', JSON.stringify(state.volume))
    },
    // 清空头部的面包蟹导航
    CLEAR_MENUNAMES (state) {
      state.menuNames = []
      // 存储到sessionStorage中
      sessionStorage.setItem('menuNames', JSON.stringify(state.menuNames))
    },
    // 添加头部的历史记录导航
    ADD_TABS (state, tab) {
      // 添加时判断数组中是否已经存在
      const index = state.navTab.findIndex(navTabs => tab.path === navTabs.path)
      if (index !== -1) {
        return false
      }
      state.navTab.push(tab)
      // 存储到sessionStorage中
      sessionStorage.setItem('navTab', JSON.stringify(state.navTab))
    },
    // 删除头部的历史记录导航
    DELETE_TABS (state, index) {
      state.navTab.splice(index, 1)
      // 存储到sessionStorage中
      sessionStorage.setItem('navTab', JSON.stringify(state.navTab))
    }
  }
}
